import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Close14 = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.64341 6.99901L13.6552 1.99813C14.1123 1.54103 14.1123 0.799921 13.6552 0.342824C13.1982 -0.114275 12.4572 -0.114275 12.0002 0.342824L7 5.35536L1.99983 0.342824L1.99983 0.342825C1.5428 -0.114275 0.801797 -0.114275 0.344765 0.342824C-0.112269 0.799923 -0.112269 1.54103 0.344765 1.99813L5.35659 6.99901L0.344765 11.9999C-0.112269 12.4533 -0.115295 13.1913 0.338007 13.6484C0.34025 13.6507 0.342503 13.6529 0.344765 13.6552H0.344765C0.798067 14.1123 1.53604 14.1153 1.99307 13.6619C1.99533 13.6597 1.99759 13.6574 1.99983 13.6552L7 8.64265L12.0002 13.6552V13.6552C12.4535 14.1123 13.1914 14.1153 13.6485 13.6619C13.6507 13.6597 13.653 13.6574 13.6552 13.6552C14.1123 13.2018 14.1153 12.4637 13.662 12.0066C13.6597 12.0044 13.6575 12.0021 13.6552 11.9999L8.64341 6.99901Z"
        })
    });
